import React, { useCallback } from "react";
import { Alert, Button, Stack } from "@mantine/core";
import { IconInfoCircle } from "@tabler/icons-react";

interface Props {
  itemLabel: string;
  onDismiss: () => void;
}

export const ReceivedExternalScanInfoPanel: React.FC<Props> = ({
  itemLabel,
  onDismiss,
}) => {
  const handleDismiss = useCallback(() => {
    onDismiss();
  }, [onDismiss]);

  return (
    <Alert
      color="violet"
      variant="light"
      icon={<IconInfoCircle size={16} />}
      title="Received External Item"
    >
      <Stack gap="xs">
        <span>
          This item ({itemLabel}) was received externally and is already
          complete. No cutting action is needed. If you intended to scan a
          different slide, please re-scan.
        </span>
        <Button size="xs" variant="subtle" onClick={handleDismiss}>
          Dismiss
        </Button>
      </Stack>
    </Alert>
  );
};
